export function MyGamePage() {
   return (
      <div>
         <h1>My Game</h1>
         <p>My Games page content</p>
      </div>
   );
}
